module.exports = __webpack_public_path__ + "static/media/t-shirt_768.7766167f.jpg";